module.exports = __webpack_public_path__ + "static/rodrigo_paiva-b849eb2b6877b862d99d45104d649d62.png";